import { chapterPrerequisiteData } from "./data";
import type { ChapterPrerequisite, ExamId, SubjectId } from "./types";

/** Pure lookups over the supplied dataset. No academic content is derived here. */

export function getPrereqChapters(exam: ExamId, subject: SubjectId): ChapterPrerequisite[] {
  return chapterPrerequisiteData[exam]?.[subject] ?? [];
}

export function prereqSubjects(exam: ExamId): SubjectId[] {
  const group = chapterPrerequisiteData[exam] ?? {};
  return (Object.keys(group) as SubjectId[]).filter((s) => (group[s]?.length ?? 0) > 0);
}

export function hasPrereqData(): boolean {
  return prereqSubjects("jee").length > 0 || prereqSubjects("neet").length > 0;
}

const normalise = (value: string) => value.trim().toLowerCase();

/** Resolves a mandatoryChapters entry (name or id) against the same exam+subject list. */
export function findPrereqChapter(
  reference: string,
  chapters: ChapterPrerequisite[],
): ChapterPrerequisite | null {
  const key = normalise(reference);
  return (
    chapters.find((c) => normalise(c.id) === key) ??
    chapters.find((c) => normalise(c.chapter) === key) ??
    null
  );
}

export function searchPrereqChapters(
  chapters: ChapterPrerequisite[],
  query: string,
): ChapterPrerequisite[] {
  const q = normalise(query);
  if (!q) return chapters;
  return chapters.filter((c) => normalise(c.chapter).includes(q));
}
